import React, { FC } from 'react';
import { AImage } from '../../atoms/AImage/index';
import { ASubheader } from '../../atoms/ASubheader/index';
import { ABody } from '../../atoms/ABody/index';
import { AIcon } from '../../atoms/AIcon/index';
import type { OCardMiniImageProps } from './OCardMiniImage.types';
import * as Styled from './OCardMiniImage.styles';

export const OCardMiniImage: FC<OCardMiniImageProps> = ({
  componentId = 'o-card-mini-image',
  externalLink = false,
  ctaLink,
  aImage,
  aSubheader,
  aBody,
  aIcon,
  className,
  ...rest
}) => {
  const CardContent = (
    <>
      {aImage && (
        <Styled.ImageWrapper>
          <AImage
            image={aImage.image}
            renditions={aImage.renditions}
            loading={aImage.loading}
            alt={aImage.alt}
            src={aImage.src}
          />
        </Styled.ImageWrapper>
      )}
      <Styled.ContentWrapper>
        {aSubheader && (
          <Styled.SubheaderWrapper>
            <ASubheader text={aSubheader.text} size={aSubheader.size} element={aSubheader.element} />
          </Styled.SubheaderWrapper>
        )}
        {aBody && (
          <Styled.BodyWrapper>
            <ABody bodyText={aBody.bodyText} size={aBody.size} color={aBody.color} />
          </Styled.BodyWrapper>
        )}
        {aIcon && externalLink && (
          <Styled.IconWrapper>
            <AIcon icon={aIcon.icon} size={aIcon.size} />
          </Styled.IconWrapper>
        )}
      </Styled.ContentWrapper>
    </>
  );

  return (
    <Styled.Wrapper data-componentid={componentId} className={className} {...rest}>
      {externalLink && ctaLink ? (
        <Styled.LinkWrapper href={ctaLink} target="_blank" rel="noopener noreferrer">
          {CardContent}
        </Styled.LinkWrapper>
      ) : (
        CardContent
      )}
    </Styled.Wrapper>
  );
};

export type { OCardMiniImageProps };
